var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPathInvision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2648_2425)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2648_2425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.122 0H10.8783C4.87031 0 0 4.87031 0 10.8783V109.122C0 115.13 4.87031 120 10.8783 120H109.122C115.13 120 120 115.13 120 109.122V10.8783C120 4.87031 115.13 0 109.122 0Z",
    fill: "#DC395F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1037 37.7556C44.0928 37.7556 47.4345 34.629 47.4345 30.5312C47.4345 26.4362 44.0928 23.3101 40.1037 23.3101C36.1146 23.3101 32.7739 26.4362 32.7739 30.5312C32.7739 34.6285 36.1146 37.7556 40.1037 37.7556ZM24.904 76.4369C24.4732 78.2697 24.2571 80.2488 24.2571 81.8631C24.2571 88.2246 27.7067 92.4475 35.0375 92.4475C41.1171 92.4475 46.0461 88.8372 49.595 83.0074L47.4279 91.7041H59.5006L66.4006 64.0295C68.1256 57.0226 71.4673 53.3856 76.5345 53.3856C80.5231 53.3856 83.0023 55.8662 83.0023 59.9612C83.0023 61.1476 82.8945 62.44 82.4632 63.842L78.9054 76.5625C78.3664 78.3953 78.1517 80.2291 78.1517 81.9527C78.1517 87.9916 81.7081 92.4086 89.1467 92.4086C95.5071 92.4086 100.573 88.3141 103.377 78.5036L98.6337 76.6727C96.2618 83.245 94.2134 84.4333 92.5962 84.4333C90.979 84.4333 90.1165 83.3561 90.1165 81.2013C90.1165 80.2309 90.3331 79.1542 90.6556 77.8577L94.1061 65.4648C94.9681 62.5548 95.292 59.9743 95.292 57.6034C95.292 48.3324 89.6857 43.494 82.8945 43.494C76.5345 43.494 70.0657 49.231 66.8323 55.269L69.2032 44.4315H50.7701L48.1826 53.9771H56.8072L51.4962 75.2397C47.3257 84.5106 39.665 84.6611 38.7036 84.446C37.1248 84.0897 36.1151 83.4902 36.1151 81.4389C36.1151 80.2553 36.3307 78.5552 36.8698 76.5053L44.9557 44.4315H24.4732L21.8857 53.9771H30.4015L24.9045 76.4369",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2648_2425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2648_2425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathInvision);
export default __webpack_public_path__ + "static/media/path-invision.82793597a8c2babcf6e01eb208bcac16.svg";
export { ForwardRef as ReactComponent };